import { gql } from "@apollo/client";

export const QUERY_USER_API_KEYS = gql`
  query UserApiKeys {
    userApiKeys {
      items {
        id
        keyType
        createdAt
        updatedAt
      }
    }
  }
`;

export const MUTATION_STORE_USER_API_KEY = gql`
  mutation StoreUserApiKey($input: StoreUserApiKeyInput!) {
    storeUserApiKey(input: $input) {
      id
      keyType
      createdAt
      updatedAt
    }
  }
`;

export const MUTATION_DELETE_USER_API_KEY = gql`
  mutation DeleteUserApiKey($id: ID!) {
    deleteUserApiKey(userApiKeyId: $id) {
      success
    }
  }
`;
